import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> p {
		font-size: 1.3rem;
		color: ${color.interface.lightGray};
		animation: show alternate-reverse ease 1s infinite;
		transition: all ease 0.5s;

		@keyframes show {
			0% {
				opacity: 0;
			}
			100% {
				opacity: 1;
			}
		}
	}
`;

interface propsLoading {
	width: number;
	colorBackgound: string;
}

const loading: any = styled.div<propsLoading>`
	border: ${(props) => `${(props.width * 10) / 100}px`} solid lightgray;
	width: ${(props: propsLoading) => `${props.width}px`};
	height: ${(props: propsLoading) => `${props.width}px`};
	border-top: ${(props: propsLoading) => `${(props.width * 10) / 100}px`} solid
		${(props: propsLoading) => props.colorBackgound};
	border-radius: 50%;

	animation: spin 1s linear infinite;

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
`;

export const loadingStyled = styled(loading).withConfig({
	shouldForwardProp: (prop) => !['width', 'colorBackgound'].includes(prop)
})``;
